import * as React from "react";
import { DataGridContext } from "../context/DataGridContext";
import { Box,  Typography } from "@mui/material";
import { Colours } from "../assets/global/Theme-variable";
import { Close } from "@mui/icons-material";
import { DisguisedTextField } from "./DisguisedTextField";
import { SortableList } from "./SortableList";
import { checkPermissions } from "../views/AccessControl";
import { useUserState } from "../context/UserContext";

export const Modifier = ({
	removeItem,
	modifiers,
	mod,
}) => {
	const { data,  } = React.useContext(DataGridContext);
	const userPermission = useUserState()

	const index = modifiers.findIndex((modifier) => modifier.id === mod.id);
	const [focused, setFocused] = React.useState(false);

	const changePrice = (event) => {
		mod.modifier = parseFloat(event.target.value);
	};

	return (
		<Box
			sx={{
				listStyle: "none",
				padding: 0,
				display: "flex",
				flexDirection: "row",
				width: "100%",
				mb: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					width: "100%",
					flexDirection: "row",
					alignItems: "center",
					backgroundColor: Colours.fieldBackground,
					// backgroundColor: "grey",
					justifyContent: "space-between",
					padding: 1,
					borderRadius: 1,

					// margin: 4,
				}}
			>
				<Box
					sx={{
						// width: "70%",
						display: "flex",
						flexDirection: "row",
						// backgroundColor: Colours.fieldBackground,
						flex: 1,
					}}
				>
					<Typography
						sx={{
							fontSize: 12,
							color: Colours.gsblue,
							ml: 2,
							userSelect: "none",
						}}
					>
						{index + 1}
					</Typography>
					<Typography
						sx={{
							fontSize: 12,
							color: Colours.gsblue,
							ml: 2,
							userSelect: "none",
						}}
					>
						{
							data?.sites?.find((site) => site?.site_ref === mod?.ref)
								?.site_name
						}
						{mod.priceBand &&
							"- " +
								data?.priceband?.find(
									(band) => band.priceband_ref === mod?.priceBand
								)?.priceband_name}
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						alignItems: "center",
						flexDirection: "row",
						width: "30%",
						mr: 5,
					}}
				>
					<DisguisedTextField
						value={mod?.modifier}
						disabled={
							!checkPermissions(userPermission, {
								page: "items",
								// allow: false,
								strict: false,

								action: "edit",
							})
						}
						focused={focused}
						setFocused={setFocused}
						onChange={changePrice}
					/>
				</Box>
				{checkPermissions(userPermission, {
					page: "items",
					// allow: false,
					strict: false,

					action: "edit",
				}) === true && <SortableList.DragHandle />}
			</Box>
			{checkPermissions(userPermission, {
				page: "items",
				// allow: false,
				strict: false,

				action: "edit",
			}) === true && (
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						width: 55,
					}}
				>
					<Close
						style={{
							color: Colours.gsblue,
							padding: 0,
							fontSize: "medium",
						}}
						onClick={() => removeItem(mod.id)}
					/>
				</Box>
			)}
		</Box>
	);
};
